module.exports = __webpack_public_path__ + "static/media/creativity1.7ed1debe.png";